import { render, staticRenderFns } from "./MedicinesTypeInfo.vue?vue&type=template&id=2450c80e&scoped=true&"
import script from "./MedicinesTypeInfo.vue?vue&type=script&lang=js&"
export * from "./MedicinesTypeInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2450c80e",
  null
  
)

export default component.exports